import React from 'react';

const testimonials = [
    {
        name: "Ahmad Hisyam",
        role: "Security Researcher",
        text: "SiberLab ID helped me understand real-world attack scenarios. The hands-on labs are super useful, and I love that it's all in Bahasa Indonesia!",
    },
    {
        name: "Alya Hanaputri",
        role: "Web Developer",
        text: "Their red team service revealed critical flaws in our infrastructure. Professional, efficient, and worth every penny.",
    },
    {
        name: "Nicholas B",
        role: "Cybersecurity Student",
        text: "We’ve used their training modules across departments. The gamification really helps team members engage deeply with the material.",
    },
];

const Testimonials = () => {
    return (
        <section id="testimonials" className="bg-[#1a1a1a] text-white px-6 md:px-16 py-20">
            <div className="text-center mb-12">
                <h2 className="text-3xl font-bold">
                    What They Say <span className="text-red-500">About Us</span>
                </h2>
                <p className="text-gray-400 mt-2 max-w-2xl mx-auto">
                    Hear from clients and learners who have experienced our services firsthand.
                </p>
            </div>

            <div className="grid md:grid-cols-3 gap-8">
                {testimonials.map((t, idx) => (
                    <div
                        key={idx}
                        className="bg-[#121212] p-6 rounded-lg border border-gray-700 shadow-lg hover:border-red-500 transition"
                        data-aos="fade-up"
                        data-aos-delay={idx * 150}
                    >
                        <div className="mb-4">
                            <div className="w-12 h-12 rounded-full bg-red-600 text-white flex items-center justify-center font-bold text-lg mb-2 mx-auto">
                                {t.name[0]}
                            </div>
                            <h4 className="text-lg font-semibold">{t.name}</h4>
                            <p className="text-sm text-gray-400">{t.role}</p>
                        </div>
                        <p className="text-gray-300 text-sm leading-relaxed">“{t.text}”</p>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Testimonials;
